<template>
<div class="BannerPreview">
<!--  <div-->
<!--    v-if="!uploadFile.isUpload"-->
<!--    :class="'BannerPreview__wrapper d-flex align-center bg-whiter profile-board justify-space-between '"-->
<!--  >-->
<!--    <div>-->
<!--      <v-img-->
<!--        src="@/assets/images/adminPanel/empty_star.webp"-->
<!--        max-width="136px"-->
<!--        :class="'BannerPreview__img'"-->
<!--      />-->
<!--    </div>-->
<!--    <div :class="'BannerPreview__title'">Баннер не загружен</div>-->
<!--    <div>-->
<!--      <v-img-->
<!--        src="@/assets/images/adminPanel/empty_star.webp"-->
<!--        max-width="136px"-->
<!--        :class="'BannerPreview__img'"-->
<!--      />-->
<!--    </div>-->
<!--  </div>-->
  <div
    v-if="uploadFile.isUpload"
    class="d-flex justify-center"
  >
    <v-img
      class="cursor-pointer"
      :src="uploadFile.image"
      @click="$emit('clickBanner')"
      contain
      max-width="500px"
    />
  </div>
</div>
</template>

<script>
/**
 * Компонент: BannerPreview
 * Описание:
 */
export default {
  name: 'BannerPreview',

  components: {},

  props: {
    uploadFile: {
      type: Object,
      default: () => ({
        isUpload: false,
        image: null,
      }),
    }
  },
  emits: ['clickBanner'],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.BannerPreview {
  &__wrapper{
    padding: 0 100px;
    min-height: 236px;
    @media (max-width: 1000px) {
      padding: 0 50px;
      min-height: 186px;

    }
  }
  &__title{
    font-size: 20px;
  }
  &__img{
    height: 130px;
  }
}
</style>
